import { Card, Collapse, Image } from "react-bootstrap";
import InboxChats from "./Pages/InboxManagement/InboxChats";
import { useApp } from "./APIHelpers/AppContext";
import { useEffect, useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { BsArrowDownSquare, BsArrowUpSquare } from "react-icons/bs";
import { inboxServices } from "./APIServices/SitePilotManagement/inboxServices";

function Chatbox() {
  const [minimize, setMinimize] = useState([]);
  const [messagesMap, setMessagesMap] = useState({});

  const { handleRemoveChat, currentUserData, handleChatClick, chatList } = useApp();

  const handleMinimizeMaximize = (id, type) => {
    if (!type) {
      setMinimize((prev) => {
        let updated = [...prev, id];
        if (updated.length > 3) updated.shift();
        return updated;
      });
    } else {
      setMinimize((prev) => prev.filter((item) => item !== id));
    }
  };

  const setInboxMessages = (inboxId, sessionId, updater) => {
    setMessagesMap((prev) => {
      const prevMsgs = prev[`${inboxId}_${sessionId}`] || [];
      const newMsgs =
        typeof updater === "function"
          ? updater(prevMsgs)
          : updater;
      return {
        ...prev,
        [`${inboxId}_${sessionId}`]: newMsgs,
      };
    });
  };

  const getSingleInbox = async (inboxId, sessionId) => {
    let data = await inboxServices.getSingleInbox(inboxId, sessionId);
    handleChatClick(data?.data || "");
  };

  useEffect(() => {
    if (!chatList?.length) return;
    setMessagesMap((prev) => {
      const updated = { ...prev };
      for (const element of chatList) {
        updated[`${element.inboxId}_${element.sessionId}`] = element.messages || [];
      }
      return updated;
    });
  }, [chatList]);

  return (
    <>
      {chatList?.map((inboxData) => {
        const inboxId = inboxData?.inboxId;
        const sessionId = inboxData?.sessionId;
        return (
          <Collapse key={inboxId} in={!!inboxData}>
            <Card className="shadow" style={{ width: "20rem" }}>
              <Card.Header className="hstack justify-content-between px-2">
                <div className="hstack gap-2">
                  <Image
                    src={inboxData?.icon}
                    alt={inboxData?.name}
                    roundedCircle
                    width={15}
                    height={15}
                  />
                  <span
                    className="text-truncate"
                    style={{ fontSize: 12, width: 180 }}
                  >
                    {inboxData?.type === "inbox"
                      ? inboxData?.name
                      : inboxId}
                  </span>
                </div>

                <div className="hstack gap-2">
                  {(
                    minimize.includes(`${inboxId}_${sessionId}`)
                      ? BsArrowUpSquare
                      : BsArrowDownSquare
                  )({
                    style: { fontSize: 11 },
                    className: "CP",
                    onClick: () =>
                      handleMinimizeMaximize(
                        `${inboxId}_${sessionId}`,
                        minimize.includes(`${inboxId}_${sessionId}`)
                      ),
                  })}

                  <FaXmark
                    style={{ fontSize: 14 }}
                    className="CP text-danger"
                    onClick={() => handleRemoveChat(inboxData)}
                  />
                </div>
              </Card.Header>

              <Collapse in={!minimize.includes(`${inboxId}_${sessionId}`)}>
                <div>
                  <InboxChats
                    category={inboxData?.type}
                    inboxData={inboxData}
                    currentUserData={currentUserData}
                    getSingleInbox={getSingleInbox}
                    getInboxList={() => { }}
                    setSessionId={() => { }}
                    sessionId={sessionId}
                    type="miniChat"
                    messages={messagesMap[`${inboxId}_${sessionId}`] || inboxData?.messages || []}
                    setMessages={(msgs) =>
                      setInboxMessages(inboxId, sessionId, msgs)
                    }
                  />
                </div>
              </Collapse>
            </Card>
          </Collapse>
        );
      })}
    </>
  );
}

export default Chatbox;
